import { useState } from "react";
import PropTypes from "prop-types";
import TextButton from "@shared/v2/TextButton";

const TeamMember = ({ teamMember, roleTitle }) => (
  <div key={teamMember.id} className="tw-flex tw-items-center tw-gap-[16px]">
    <div className="tw-flex [&>.circled]:!tw-m-0" dangerouslySetInnerHTML={{ __html: teamMember.image }} />
    <div>
      <div className="tw-text-12d tw-leading-[12px] tw-font-semibold">{teamMember.name}</div>
      <div className="tw-text-[10px] tw-leading-[10px] tw-font-bold">{roleTitle}</div>
    </div>
  </div>
);

TeamMember.propTypes = {
  teamMember: PropTypes.shape().isRequired,
  roleTitle: PropTypes.string.isRequired,
};

const NonPrimaryTeamMembers = ({ nonPrimaryTeamMembers, allAssignableRoles }) => {
  const [showMore, setShowMore] = useState(false);

  const findRoleTitle = (roleId, userType) =>
    allAssignableRoles?.find((r) => r.id === roleId)?.title || userType;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[8px]">
      {nonPrimaryTeamMembers.slice(0, 2).map((teamMember) => (
        <TeamMember
          key={teamMember.id}
          teamMember={teamMember}
          roleTitle={findRoleTitle(teamMember.role_id, teamMember.user_type)}
        />
      ))}

      {showMore &&
        nonPrimaryTeamMembers
          .slice(2)
          .map((teamMember) => (
            <TeamMember
              key={teamMember.id}
              teamMember={teamMember}
              roleTitle={findRoleTitle(teamMember.role_id, teamMember.user_type)}
            />
          ))}
      {nonPrimaryTeamMembers.length > 2 && (
        <TextButton className="tw-self-start" onClick={() => setShowMore((more) => !more)}>
          {`${showMore ? "-" : "+"}${nonPrimaryTeamMembers.length - 2} ${showMore ? "Less" : "More"}`}
        </TextButton>
      )}
    </div>
  );
};

NonPrimaryTeamMembers.propTypes = {
  nonPrimaryTeamMembers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  allAssignableRoles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default NonPrimaryTeamMembers;
